$(document).ready(function () {
    $('#mi-corpo-load-more-blog-posts-button').on('click', function () {
        const $miCorpoBlogHomePageSelector = $('#mi-corpo-blog-home-page-selector');
        loadBlogPosts(parseInt($('#mi-blog-posts-page').val()) + 1, $miCorpoBlogHomePageSelector.find('option:selected').val());
    });

    $(window).resize(function () {
        adjustCategoriesListDisplay();
    });

    removeParamFromCanonical();

    $(window).on('popstate', function (event) {
        const state = event.originalEvent.state;

        if (!state) {
            return;
        }

        const category = state.category;
        loadBlogPostsAndCategories(category);
    });
});

function completeCategoriesConfiguration() {// eslint-disable-line no-unused-vars
    adjustCategoriesListDisplay();

    initializeCategorySelector();
    addEvenFilterByCategoryForElements('#mi-blog-categories-tag-list .mi-blog-category-tag-link');

    displayLoadingCategoriesImage(false);
}

function completeBlogPostsConfiguration(currentPageNumber, pageSize, areThereMoreBlogPostsToDisplay) {// eslint-disable-line no-unused-vars
    updatePageValue(currentPageNumber);
    updatePageSizeValue(pageSize);

    addEvenFilterByCategoryForElements('.mi-blog-article-body-tags .mi-blog-category-tag-link');

    displayLoadingBlogPostsImage(false);
    displayLoadMoreButton(areThereMoreBlogPostsToDisplay);
}

function initializeCategorySelector() {
    const $miCorpoBlogHomePageSelector = $('#mi-corpo-blog-home-page-selector');

    $miCorpoBlogHomePageSelector.on('change', function () {
        const newSelectedCategory = $miCorpoBlogHomePageSelector.find('option:selected').val();
        updateListOfCategories(newSelectedCategory);

        // Add category to URL
        const queryString = newSelectedCategory ? `?category=${newSelectedCategory}` : '';
        const newUrl = window.location.pathname + queryString;
        history.pushState({ category: newSelectedCategory }, '', newUrl);

        loadBlogPostsForSelectedCategory(newSelectedCategory);
    });
}

function addEvenFilterByCategoryForElements(elementsClass) {
    const $categorySelector = $('#mi-corpo-blog-home-page-selector');

    $(elementsClass).each(function () {
        const $this = $(this);
        const category = $this.attr('data-category');
        $this.off('click').click(function (e) {
            e.preventDefault();
            $categorySelector.val(category).change();
        });
    });
}

function updateListOfCategories(newSelectedCategory) {
    const newSelectedCategoryListElement = $('a.mi-blog-category-tag-link[data-category=\'' + newSelectedCategory + '\']');
    setListCategorySelectedElementAs(newSelectedCategoryListElement);
}

function setListCategorySelectedElementAs(newSelectedElement) {
    const selectedItemClass = 'mi-blog-category-tag-link-selected';

    $('.' + selectedItemClass).removeClass(selectedItemClass);
    newSelectedElement.addClass(selectedItemClass);
}

function loadBlogPostsForSelectedCategory(selectedCategory) {
    moveFocusToBlogWidgetTop();
    cleanCurrentPostsList();
    loadBlogPosts(1, selectedCategory);
}

function moveFocusToBlogWidgetTop() {
    $('#mi-blog-posts-page-anchor-name').focus();
}

function cleanCurrentPostsList() {
    $('#mi-blog-posts-list').html('');
}

function removeParamFromCanonical() {
    const url = location.protocol + '//' + location.host + location.pathname;
    $('link[rel=canonical]').attr('href', url);
}

function loadBlogPostsAndCategories(initialSelectedCategory) {
    displayLoadingCategoriesImage(true);

    const language = getLanguageToUse();

    doesCategoryExists(initialSelectedCategory).then(function (doesCatExists) {
        doesCatExists = (doesCatExists === true || doesCatExists.toLowerCase() === 'true');

        if (!doesCatExists && initialSelectedCategory !== '') {
            $('#dynamicBlogErrorModal').modal('show');
            const url = new URL(window.location.href);
            url.searchParams.delete('category');
            history.replaceState({ category: '' }, '', url);
            initialSelectedCategory = '';
        }
        else {
            history.replaceState({ category: initialSelectedCategory }, '', window.location.href);
        }

        const requestManager = new AsyncRequestManager(); // eslint-disable-line no-undef

        requestManager.renderAsyncRequest(
            '/blogdynamichomepage/loadblogpostscategories',
            '?selectedItemId=' + $('#mi-corpo-blog-selectedItemId').val() +
            '&selectedCategory=' + initialSelectedCategory,
            '#mi-corpo-blog-categories',
            false,
            language,
            '#mi-corpo-loading-image-blog-categories'
        );

        loadBlogPosts(1, initialSelectedCategory);
    });
}

function doesCategoryExists(category) {
    return $.ajax({
        url: '/blogdynamichomepage/doesBlogCategoryExist',
        data: 'category=' + category,
        type: 'GET'
    }).catch(function () {
        return false;
    });
}

function loadBlogPosts(page, category) {
    displayLoadMoreButton(false);
    displayLoadingBlogPostsImage(true);

    const blogPostsUrl = '/blogdynamichomepage/loadblogposts';
    const queryString = '?page=' + page
        + '&pageSize=' + $('#mi-blog-posts-page-size').val()
        + '&selectedItemId=' + $('#mi-corpo-blog-selectedItemId').val()
        + '&selectedCategory=' + category;
    const blogPostsElementId = '#mi-blog-posts-list';
    const blogPostLoadingImageElementId = '#mi-corpo-loading-image-blog-posts';

    const language = getLanguageToUse();
    const requestManager = new AsyncRequestManager();// eslint-disable-line no-undef

    if (page == 1) {
        requestManager.renderAsyncRequest(blogPostsUrl, queryString, blogPostsElementId, false, language, blogPostLoadingImageElementId);
    }
    else {
        requestManager.renderAsyncAppenderRequest(blogPostsUrl, queryString, blogPostsElementId, language, blogPostLoadingImageElementId);
    }
}

function displayLoadMoreButton(displayAsVisible) {
    displayElement('#mi-corpo-load-more-blog-posts-button', displayAsVisible);
}

function displayLoadingCategoriesImage(displayAsVisible) {
    displayElement('#mi-corpo-loading-image-blog-categories', displayAsVisible);
}

function displayLoadingBlogPostsImage(displayAsVisible) {
    displayElement('#mi-corpo-loading-image-blog-posts', displayAsVisible);
}

function displayElement(domElementName, displayAsVisible) {
    if (displayAsVisible) {
        $(domElementName).show();
    }
 else {
        $(domElementName).hide();
    }
}
function adjustCategoriesListDisplay() {
    if ($(window).width() >= 1024) {
        $('#mi-blog-categories-combo').hide();
        $('#mi-blog-categories-tag-list').show();
    }
 else {
        $('#mi-blog-categories-combo').show();
        $('#mi-blog-categories-tag-list').hide();
    }
}

function getLanguageToUse() {
    return $('#mi-corpo-blog-displayOnlyEnglishBlogPosts').val().toLowerCase() == 'true' ? 'en' : $('html').attr('lang');
}

function updatePageValue(newPageValue) {
    $('#mi-blog-posts-page').val(newPageValue);
}

function updatePageSizeValue(newPageSizeValue) {
    $('#mi-blog-posts-page-size').val(newPageSizeValue);
}

function getUrlSelectedCategory() {// eslint-disable-line no-unused-vars
    const selectedCategoryParamName = 'category';
    const urlParams = new URLSearchParams(window.location.search);

    return urlParams.has(selectedCategoryParamName) ? urlParams.get(selectedCategoryParamName) : '';
}
